import { render, staticRenderFns } from "./ReachPanel.vue?vue&type=template&id=3c230c1a"
import script from "./ReachPanel.vue?vue&type=script&lang=js"
export * from "./ReachPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports